import { render, staticRenderFns } from "./FunctionalPositionDetailForm.vue?vue&type=template&id=bb39cf2a&"
import script from "./FunctionalPositionDetailForm.vue?vue&type=script&lang=js&"
export * from "./FunctionalPositionDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports